// NOTE: Values are based off of https://company-24073.frontify.com/d/0fSeBVw4iFUq/yoco-style-guide#/basics/colours and website sketch files

// NOTE: NEVER reference ColorConsts in code
// TODO: Remove deprecaited colors (Speak to Ryno)
const colorConsts = {
  // Yoco-blue
  blue: '#00A2E0',
  blueDark: '#384967',
  white: '#FFFFFF',
  // TODO: Rename navy-grey
  black: '#2d3033',
  // Remove grey
  grey: '#515151',
  // nicole-grey
  greyL2: '#f8f8f8',

  greyD1: '#595959',
  greyD2: '#2c3033',
  greyD3: '#D8D8D8',
  greyD4: '#2d3033',
  greyL1: '#CCCECE',
  purple: '#8B84D7',
  green: '#48A23F',
  greenV2: '#4caf50',
  yellow: '#FFC72C',
  orange: '#FF8200',
  red: '#DA291C',
}

const colors = {
  primary: colorConsts.blue,
  secondary: colorConsts.blueDark,
  success: colorConsts.green,
  danger: colorConsts.red,
  warning: colorConsts.orange,
  info: colorConsts.grey,
  light: colorConsts.greyL1,
  faded: colorConsts.greyD4,
  dark: colorConsts.greyD2,
  muted: colorConsts.greyL2,
  white: colorConsts.white,
  black: colorConsts.black,
  green: colorConsts.greenV2,
}

// NOTE: Colours declared by their intent. These are the variables to use.
export const palette = {
  text: colors.black,
  background: colors.white,
  backgroundAlt: colors.muted,
  backgroundInverse: colors.dark,
  backgroundBlueGrey: colors.secondary,
  action: colors.primary,
  actionInverse: colors.white,
  info: colors.info,
  disabled: colors.muted,
  neutral: colors.white,
  border: colors.faded,
  shadow: colors.dark,
  invalid: colors.warning,
  green: colors.green,
}

export const fontFamily = {
  base: 'basierCircle',
}

export const fontWeight = {
  base: 'normal',
  bold: 'bold',
  semiBold: 600,
}

export const lineHeight = {
  base: 1.56,
}

// NOTE: Set global font-size on body tag then use fluid values everywhere
export const sizesFixed = {
  base: '16px',
  xxs: '4px',
  xs: '7px',
  sm: '10px',
  md: '24px',
  lg: '36px',
  xl: '54px',
  xxl: '81px',
  mega: '121px',
}

// NOTE: Generated using type-scale. https://type-scale.com/?size=16&scale=1.500&text=A%20Visual%20Type%20Scale&font=PT%20Sans&fontweight=400&bodyfont=Poppins&bodyfontweight=400&lineheight=1.45&backgroundcolor=white&fontcolor=%23333&preview=false
const sizesScaled = {
  base: '1rem', // base = 16px
  xxs: '0.296rem',
  xs: '0.444rem',
  sm: '0.667rem',
  md: '1.5rem', // 24px with a 16 base
  lg: '2.5rem', // 36px with a 16 base
  xl: '3.375rem',
  xxl: '5.063rem',
  mega: '7.594rem',
  container: '1366px',
}

export const sizes = sizesScaled
export const fontSizes = sizesScaled

export const radius = {
  base: '4px',
  l1: '',
}

export const stroke = {
  base: '1px',
}

export const zIndex = {
  base: 100,
  float: 300,
  background: 50,
  foreground: 200,
  alerts: 1000,
  modals: 900,
  sheets: 800,
  _donotUse: 99999,
}

export const speed = {
  base: '300ms',
  fast: '150ms',
  slow: '500ms',
}



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/design/StyleGuide/StyleGuide.js